import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLocation } from 'redux/actions/location';
import Loader from 'components/Loader';
import { APP } from 'libs/constants';
import { endPoints } from 'config/routes';
import { redirectTo } from 'libs/common';
import {
  checkNonTrialActiveSubscription,
  checkTrialSubscriptionWithPlan,
  checkTrialSubscriptionWithoutPlan,
  hadNoTrialOrPromoSubs,
} from 'libs/musePromoPlans';
import HeaderLayout from './HeaderLayout';

class HeaderLayoutMuseAndroidPromo extends React.Component {
  constructor(props) {
    super(props);

    this.redirectSubscriptions = true;
    this.non_trial = false;
  }

  componentWillMount() {
    this.props.getLocation();
  }

  componentDidUpdate() {
    const {
      userSubscriptions,
      user
    } = this.props;

    const query = window.appHistory &&
                  window.appHistory.location &&
                  window.appHistory.location.search;

    if (hadNoTrialOrPromoSubs(user, APP.muse)) {
      this.redirectSubscriptions = false;
      this.non_trial = true;
    } else if (
      checkNonTrialActiveSubscription(userSubscriptions) ||
      checkTrialSubscriptionWithPlan(userSubscriptions)
    ) {
      redirectTo(endPoints.subscriptions, query);
    } else if (
      checkTrialSubscriptionWithoutPlan(userSubscriptions, APP.muse) ||
      !hadNoTrialOrPromoSubs(user, APP.muse)
    ) {
      redirectTo(endPoints.products.muse.promo, query);
    }
  }

  render() {
    const { location } = this.props;
    if (this.redirectSubscriptions || location.isFetching) {
      return <Loader />;
    }

    return (
      <div className="Layout--Header--MuseAndroidPromo">
        <HeaderLayout
          {...this.props}
          nonTrial={this.non_trial}
          headerProps={{
            showCountryDrop: true
          }}
        />
      </div>
    );
  }
}

HeaderLayoutMuseAndroidPromo.propTypes = {
  getLocation: PropTypes.func.isRequired,
  userSubscriptions: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

function mapStateToProps({
  auth,
  location
}) {
  return {
    user:
      (auth.info && auth.info.user) || {},
    userSubscriptions: (auth.info && auth.info.subscriptions) || [],
    location
  };
}
export default connect(mapStateToProps, { getLocation })(HeaderLayoutMuseAndroidPromo);



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderLayout/HeaderLayoutMuseAndroidPromo.jsx